getRootIdSet